import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentService } from '../../../../../../../shared/services/document/document.service';

@Component({
  selector: 'app-equity-learner-documents',
  templateUrl: './equity-learner-documents.component.html',
  styleUrls: ['./equity-learner-documents.component.scss'],
  standalone: false,
})
export class EquityLearnerDocumentsComponent implements OnInit {
  learnerId: string;
  learnerName: string;
  pageTitle: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly documentService: DocumentService
  ) {}

  ngOnInit(): void {
    this.learnerId = this.route.snapshot.paramMap.get('learnerId');
    this.learnerName = this.route.snapshot.queryParamMap.get('learnerName');
    this.pageTitle = `Documentation - ${this.learnerName}`;
  }
}
